import { QueryKey } from "@tanstack/react-query";

export const sales = {
  all: () => ["sales"] as QueryKey,
};
